// extracted by mini-css-extract-plugin
export default {"month":"DetallesLeads_month__KUBlx","year":"DetallesLeads_year__VghfF","section":"DetallesLeads_section__Kqxjp"};